import React, { useEffect, useState } from "react";
import HeaderAdmin from "../../../Components/HeaderAdmin/Header";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { buildStGet } from "../../../Api/buildST";

function StationList() {
    const [buildDta, setBuildDta] = useState([]);

    useEffect(() => {
        getDataById();
    }, []);

    const getDataById = () => {
        buildStGet()
            .then((res) => {
                const Data = res.data.data;
                setBuildDta(Data);
            })
            .catch((err) => {
                alert(err);
            });
    };

 
    return (
        <>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>

            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="sec-header-dash">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Station List</h3>
                                        </div>
                                        <div className="content-box-btn">
                                            <Link to="/buildstation-add">
                                                <button className="btn btn-add">Add</button>
                                            </Link>
                                        </div>
                                    </div>
                                    {buildDta.map((item, index) => (
                                        <div className="form-box-section mt-3" key={index}>
                                            <div className="profile">
                                                <div className="profile-details">
                                                    <div className="user-name">
                                                        <h3>{item.build_Stations_name}</h3>
                                                    </div>
                                                    <div className="user-email">
                                                        {item.build_Stations_id}
                                                    </div>
                                                </div>
                                                <div className="content-box-btn">
                                                    <Link to={`/buildstation-view/${item._id}`}>
                                                        <button className="btn btn-edit"><FaEye /></button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default StationList;
